import { requestAds } from "./ads";
import { activateTypingAnimations } from "./animations";
import { activateAuthForm } from "./auth";
import { activateAutocompleteField } from "./autocomplete";
import { activateBotControl } from "./bot";
import { count } from "./count";
import { activateMobileControls } from "./mobile";
import { activatePrelaunchTarget } from "./prelaunch";
import { activatePaymentForm } from "./stripe";

function activateJavascriptControls() {
  for (const el of document.querySelectorAll<HTMLElement>(".nav-item-js")) {
    el.style.display = "inline-block";
  }
}

interface SuggestItem {
  query: string;
  title?: string;
  description?: string;
  img?: string;
}

interface SuggestResponse {
  data: SuggestItem[];
}

function activateWebSearchAutocompleteField() {
  activateAutocompleteField("web-search-input", async (query) => {
    const response = await fetch(
      `/search/web/suggest?q=${encodeURIComponent(query)}`,
    );
    if (!response.ok) {
      throw new Error("Bad response");
    }

    const r = (await response.json()) as SuggestResponse;
    return r.data.map((item) => ({
      label: item.query,
      sublabel: item.title,
      image: item.img,
    }));
  });
}

document.addEventListener("DOMContentLoaded", async () => {
  activateMobileControls();
  activateJavascriptControls();
  activateBotControl();
  activateTypingAnimations();
  activateWebSearchAutocompleteField();
  activateAuthForm();
  activatePrelaunchTarget();
  await activatePaymentForm();
  await count();
  await requestAds();
});
